<template>
  <div>
    <!-- 验证中... -->
    <div
      class="loading"
      v-loading="loading"
      :element-loading-text="$t('GLOBAL.Verifying')"
    ></div>
  </div>
</template>

<script>
import { loadLanguageAsync } from "@/lang/i18n";
import { queryEnabledLanguageCode, saveLocaleLanguageCode } from "@/api/user/index.js";
/* eslint-disable */
import axios from "axios";
import qs from "qs";
const instance = axios.create({
  baseURL: "/",
});
export default {
  created() {
    // 设置多语言
    this.queryEnabledLanguageCode();
  },
  data() {
    return {
      loading: true,
      langList: [],
      userLang: "",
    };
  },
  methods: {
    toTransfer () {
      if (localStorage.getItem("token")) {
        // 判断是否已登录，是否有token，如果已登录，展示用户信息和相关操作
        this.$router.push("/home");
      } else if (this.$route.query.code) {
        let params = {
          code: this.$route.query.code,
          redirectUri: Boolean(window.location.origin)
            ? window.location.origin
            : "",
        };
        let url = process.env.VUE_APP_API + "/loginByCode";
        instance({
          url,
          method: "post",
          data: qs.stringify(params),
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        })
          .then((res) => {
            localStorage.setItem("loginByCodeRes", JSON.stringify(res));
            if (res.status === 200) {
              let info = {
                token: res.data.access_token,
                ucUserInfo: res.data.user_info,
              };
              this.$store.commit("SET_LOGIN_INFO", info);
              window.location.reload();
            }
          })
          .catch(() => {});
      } else {
        this.$router.push("/home");
        this.isLogin = false;
      }
    },
    queryEnabledLanguageCode() {
      queryEnabledLanguageCode()
        .then((res) => {
          this.langList = res;
          this.$store.commit("SET_LANGUAGELIST", this.langList);
          this.userLang = "";
          // 新增语种判断 start
          // 获取
          var queryString = window.location.search.substring(1);
          let request_locale = '';
          var params = new URLSearchParams(queryString);
          let isHas_request_locale = false;
          params.forEach((value, key) => {
              if (key === 'request_locale') {
                isHas_request_locale = true;
                request_locale = value;
              }
          });
          // 判断是否是从TI跳过来的链接，是否携带参数request_locale
          if (isHas_request_locale) {
            let setLang = '';
            this.langList.map(item => {
              if (request_locale === item.languageCode.slice(0, 2)) {
                setLang = item.languageCode;
              }
            })
            // 判断根据当前浏览器获取的语种是否在当前九种语言中，如果不在默认设置成英文
            if (setLang) {
              this.userLang = setLang;
            } else {
              this.userLang = 'en_GB';
            }
          } else {
            if (localStorage.getItem("lang")) {
              this.userLang = localStorage.getItem("lang");
            } else {
              this.userLang = navigator.language || navigator.userLanguage;
            }
          }
          this.userLang = this.userLang.split("-").join("_");
          let flagI = this.langList.findIndex(
            (el) => el.languageCode === this.userLang
          );
          if (flagI >= 0) {
            localStorage.setItem("lang", this.userLang);
            loadLanguageAsync(this.userLang);
          } else {
            localStorage.setItem("lang", "en_GB");
            loadLanguageAsync("en_GB");
          }
          saveLocaleLanguageCode({
            locale: this.userLang
          }).then(() => {
            // 登录中转
            this.toTransfer();
          }).catch(() => {
            // 登录中转
            this.toTransfer();
          });
        })
        .catch(() => {
          // 登录中转
          this.toTransfer();
        });
    },
  },
};
</script>

<style scoped lang="scss">
.loading {
  width: 20rem;
  height: 20rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
